import { lang,isSystem } from '@umu/ukit-lang';
/*
  定价相关跳转
*/
import { services } from 'common';
const { Toast } = services;
import { isInApp } from '@umu/umu-ua';
import { $window, redirectTo, $location, updateUrlParameter } from '@umu/umu-dom';

import { IUserInfo, EnterpriseRoleType, PLAN_TYPE, VERSION_TYPE } from '@umu/umu-types';

const HOST = $location.protocol + '//' + $location.host;
// 商用版试用
const APPLY_FOR_COMMERICAL_TRIAL_URL = `${HOST}/plan/payment#/commerical-trial`;
// 付费记录
export const PAYMENT_HISTORY_URL = `${HOST}/payment/history`;
// 首页
export const INDEX_PAGE = `${HOST}/index`;

function stopRedirectTo() {
    if (isInApp()) {
        Toast.show(lang('暂无权限'));
        return true;
    }
    return false;
}

function redirectToProxy(url: string) {
    if (stopRedirectTo()) {
        return;
    }
    redirectTo(url);
}

export interface IRedirecdUrls {
    login: string;
    register: string;
    basicHome: string;
    professionalHome: string;
    commericalHome: string;
    contactSales: string;
    pricing: string;
    home: string;
    nonWxpaymentTips: string;
    paidUrl: string;
}

function getPageUrls(platform: string) {
    const host = HOST;
    const pageUrls: { [props: string]: IRedirecdUrls } = {
        twww: {
            basicHome: `${host}/index`,
            professionalHome: `${host}/index`,
            commericalHome: `${host}/platformManage/index#/guide`,
            login: `${host}/auth/login`,
            register: `${host}/auth/register`,
            contactSales: `${host}/cms/contact-sales`,
            pricing: `${host}/plan/pricing`,
            home: `${host}/model/home`,
            nonWxpaymentTips: '',
            paidUrl: PAYMENT_HISTORY_URL,
        },
        mobile: {
            basicHome: `${host}/`,
            professionalHome: `${host}/`,
            commericalHome: `${host}/`,
            login: `${host}/globaluser/loginpage`,
            register: `${host}/globaluser/registerpage`,
            contactSales: `${host}/cms/contact-sales`,
            pricing: `${host}/plan/pricing`,
            home: `${host}/`,
            nonWxpaymentTips: `${host}/plan/payment#/non-wx-payment`,
            paidUrl: `${host}/`,
        },
    };

    return pageUrls[platform];
}

function getPurchasePaymentUrl(platform: string, planId: PLAN_TYPE) {
    if (platform === 'twww') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${planId}&purchase=1&platform=twww`;
        }else{
            return `/plan/subscription?plan=${planId}&purchase=1&platform=twww`;
        }
    } else if (platform === 'mobile') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${planId}&purchase=1&platform=mobile`;
        }else{
            return `/plan/subscription?plan=${planId}&purchase=1&platform=mobile`;
        }
    }
    return '';
}

// 购买版本
export function redirectToPurchasePayment(platform: string, planId: PLAN_TYPE) {
    const url = getPurchasePaymentUrl(platform, planId);
    redirectToProxy(url);
}

function getQueryKey(platform: string) {
    return platform === 'twww' ? 'back' : 'from_url';
}

// 商用版账号增购，类型都是固定，但是这个类型不是定义在bussiness，什么是合理的，值得思考！
export function getPurchaseAccountQuotaPaymentUrl(platform: 'mobile' | 'twww') {
    if (platform === 'twww') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${PLAN_TYPE.COMMERICAL}&purchase=3&platform=twww`;
        }else{
            return `/plan/subscription?plan=${PLAN_TYPE.COMMERICAL}&purchase=3&platform=twww`;
        }
    } else if (platform === 'mobile') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${PLAN_TYPE.COMMERICAL}&purchase=3&platform=mobile`;
        }else{
            return `/plan/subscription?plan=${PLAN_TYPE.COMMERICAL}&purchase=3&platform=mobile`;
        }
    }
    return '';
}

// 商用版账号增购
export function redirectToPurchaseAccountQuotaPayment(platform: 'mobile' | 'twww') {
    const url = getPurchaseAccountQuotaPaymentUrl(platform);
    redirectToProxy(url);
}

// 商用版续期
export function getPurchasePeriodPaymentUrl(platform: 'mobile' | 'twww') {
    if (platform === 'twww') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${PLAN_TYPE.COMMERICAL}&purchase=2&platform=twww`;
        }else{
            return `/plan/subscription?plan=${PLAN_TYPE.COMMERICAL}&purchase=2&platform=twww`;
        }
    } else if (platform === 'mobile') {
        if(isSystem('cn')){
            return `/plan/payment?plan=${PLAN_TYPE.COMMERICAL}&purchase=2&platform=mobile`;
        }else{
            return `/plan/subscription?plan=${PLAN_TYPE.COMMERICAL}&purchase=2&platform=mobile`;
        }
    }
    return '';
}

// 商用版续期
export function redirectToPurchasePeriodPaymentPayment(platform: 'mobile' | 'twww') {
    const url = getPurchasePeriodPaymentUrl(platform);
    redirectToProxy(url);
}

function redirectOnSignIn(platform: string, planId: PLAN_TYPE, urls: IRedirecdUrls) {
    switch (planId) {
        case PLAN_TYPE.BASIC:
            redirectToProxy(urls.basicHome);
            break;
        case PLAN_TYPE.PROFESSIONAL:
            redirectToProxy(getPurchasePaymentUrl(platform, planId));
            break;
        case PLAN_TYPE.COMMERICAL:
            redirectToProxy(getPurchasePaymentUrl(platform, planId));
            break;
        default:
            break;
    }
}

function redirectOnSignOut(platform: string, planId: PLAN_TYPE, urls: IRedirecdUrls, isBuyNow?: boolean) {
    let url = '';
    const queryKey = getQueryKey(platform);
    switch (planId) {
        case PLAN_TYPE.BASIC:
            url = updateUrlParameter(urls.register, queryKey, urls.basicHome);
            redirectToProxy(`${url}`);
            break;
        case PLAN_TYPE.PROFESSIONAL:
            url = updateUrlParameter(urls.register, queryKey, HOST + getPurchasePaymentUrl(platform, planId));
            if (isBuyNow) {
                url = updateUrlParameter(urls.login, queryKey, HOST + getPurchasePaymentUrl(platform, planId));
            }
            redirectToProxy(`${url}`);
            break;
        case PLAN_TYPE.COMMERICAL:
            url = updateUrlParameter(urls.register, queryKey, HOST + getPurchasePaymentUrl(platform, planId));
            if (isBuyNow) {
                url = updateUrlParameter(urls.login, queryKey, HOST + getPurchasePaymentUrl(platform, planId));
            }
            redirectToProxy(`${url}`);
            break;
        default:
            break;
    }
}

// 跳转到定价页
export function redirectToPricing(platform: 'mobile' | 'twww') {
    const urls = getPageUrls(platform);
    const pricing = 'pricing';
    const url = urls[pricing];
    redirectToProxy(`${url}`);
}

export function redirectToPlan(platform: string, isLogin: boolean, planId: PLAN_TYPE, isBuyNow?: boolean) {
    const urls = getPageUrls(platform);
    if (isLogin) {
        redirectOnSignIn(platform, planId, urls);
    } else {
        redirectOnSignOut(platform, planId, urls, isBuyNow);
    }
}

// 专业版默认首页
export function redirectToProfessionalHome(platform: string) {
    const urls = getPageUrls(platform);
    redirectToProxy(urls.professionalHome);
}

// 商业版默认首页
export function redirectToCommericalHome(platform: string, isLogin: boolean = true) {
    const queryKey = getQueryKey(platform);
    const urls = getPageUrls(platform);
    if (isLogin) {
        redirectToProxy(urls.commericalHome);
    } else {
        const url = updateUrlParameter(urls.register, queryKey, urls.commericalHome);
        redirectToProxy(`${url}`);
    }
}

// 联系销售
export function redirectToContractSales(platform: 'mobile' | 'twww') {
    const urls = getPageUrls(platform);
    redirectTo(urls.contactSales);
}

// 通过url判断当前的页面所做的页面类型
export function getPlatform(): 'mobile' | 'twww' {
    // M端只有m的域名上有
    const href = $window.location.href;
    if (href.indexOf('//test.m.') > -1) {
        return 'mobile';
    }
    if (href.indexOf('//m.') > -1 || href.indexOf('//pin.') > -1) {
        return 'mobile';
    }
    return 'twww';
}

// 商用版免费试用申请中
export function redirectToCommericalTrial(platform: string, isLogin: boolean = true) {
    const queryKey = getQueryKey(platform);
    const urls = getPageUrls(platform);
    if (isLogin) {
        redirectToProxy(APPLY_FOR_COMMERICAL_TRIAL_URL);
    } else {
        const url = updateUrlParameter(urls.register, queryKey, APPLY_FOR_COMMERICAL_TRIAL_URL);
        redirectToProxy(`${url}`);
    }
}

// 微信环境中调转到非微信环境的页面
export function redirectToNonWxPayment() {
    const key = 'mobile';
    const urls = getPageUrls(key);
    const queryKey = getQueryKey(key);
    const url = updateUrlParameter(urls.nonWxpaymentTips, queryKey, $window.location.href);
    redirectToProxy(`${url}`);
}

// 未登录的首页
export function redirectToHome() {
    const platform = getPlatform();
    const urls = getPageUrls(platform);
    redirectToProxy(`${urls.home}`);
}

// 定价页，升级页，付费记录
// true 有权限
// false 无权限
export function checkEnterpriseAdminPermission(userInfo: IUserInfo) {
    // 未登录可以看
    if (!userInfo || !userInfo.enterprise_info) {
        return true;
    }
    const { role_type = 0, enterprise_id = 0, version_type } = userInfo.enterprise_info;
    // 非企业版
    if (!enterprise_id) {
        return true;
    }

    if (Number(version_type) === VERSION_TYPE.COMMERICAL || Number(version_type) === VERSION_TYPE.COMMERICAL_TRIAL) {
        if (Number(role_type) === EnterpriseRoleType.ADMIN) {
            return true;
        }
    }

    const platform = getPlatform();
    const urls = getPageUrls(platform);
    redirectToProxy(`${urls.basicHome}`);
    return false;
}

// 支付后页面的
export function redirectToPaidUrl() {
    const platform = getPlatform();
    const urls = getPageUrls(platform);
    return urls.paidUrl;
}

export const isProfessionalVersion = (teacherStatus: VERSION_TYPE) => {
    teacherStatus = Number(teacherStatus);
    return teacherStatus === VERSION_TYPE.PROFESSIONAL ||
        teacherStatus === VERSION_TYPE.FREE_PROFESSIONAL ||
        teacherStatus === VERSION_TYPE.EDU_PROFESSIONAL;
};
export const isBasicVersion = (teacherStatus: VERSION_TYPE) => {
    teacherStatus = Number(teacherStatus);
    return teacherStatus === VERSION_TYPE.NORMAL ||
        teacherStatus === VERSION_TYPE.EDU_BASIC;
};
